import dynamic from "next/dynamic";

import type { Props as OnboardingModalProps } from "./onboarding-modal";

export const DynamicOnboardingModal = dynamic<OnboardingModalProps>(() =>
  import("./onboarding-modal").then(module => module.OnboardingModal),
);
